import React from 'react';
import { useEditorContext } from '../../Editor/Context';
import SelectionBubbleMenu from '../SelectionBubbleMenu';
import cn from 'classnames';
import Bold from '../buttons/Bold';
import Italic from '../buttons/Italic';
import Underline from '../buttons/Underline';
import Strike from '../buttons/Strike';
import Link from '../buttons/Link';
import Separator from '../buttons/Separator';
import Alignment from '../buttons/Alignment';
import BlockFormatting from '../buttons/BlockFormatting';
import BulletList from '../buttons/BulletList';
import OrderedList from '../buttons/OrderedList';
import Blockquote from '../buttons/Blockquote';
import ClearFormatting from '../buttons/ClearFormatting';
import { getNodeFromSelection, isExtensionInstalled } from '../../utils/tiptap';
import HRule from '../buttons/HRule';
import { LinkMenuState } from '../../../extensions/extension-link-menu-handler/linkMenuHandler';
import Outdent from '../buttons/Outdent';
import Indent from '../buttons/Indent';
const FormatBubbleMenu = ({ scrollContainerRef, omitHRule = false })=>{
    const editor = useEditorContext();
    if (!editor) {
        return null;
    }
    if (!(editor === null || editor === void 0 ? void 0 : editor.isEditable)) {
        return null;
    }
    let buttonCount = 11;
    if (!isExtensionInstalled(editor, 'textAlignment')) {
        buttonCount--;
    }
    if (!isExtensionInstalled(editor, 'heading')) {
        buttonCount--;
    }
    if (!isExtensionInstalled(editor, 'bulletList')) {
        buttonCount--;
    }
    if (!isExtensionInstalled(editor, 'orderedList')) {
        buttonCount--;
    }
    if (!isExtensionInstalled(editor, 'blockquote')) {
        buttonCount--;
    }
    if (omitHRule) {
        buttonCount--;
    }
    const handlerStorage = editor.storage.linkBubbleMenuHandler;
    const menuState = handlerStorage.state;
    let workaroundLinkBubble = false;
    if (menuState === LinkMenuState.VIEW_LINK_DETAILS) {
        workaroundLinkBubble = true;
    }
    let open = editor.state.selection.empty === false;
    // Dont show for any of our exts
    const nodes = getNodeFromSelection(editor);
    if (nodes[0] && nodes[0].type.name === 'blockquote' && nodes[1] && nodes[1].type.name.startsWith('da-')) {
        open = false;
    }
    if (nodes[0] && nodes[0].type.name.startsWith('da-')) {
        open = false;
    }
    return /*#__PURE__*/ React.createElement(SelectionBubbleMenu, {
        scrollContainerRef: scrollContainerRef,
        menuHeight: 34,
        menuWidth: 32 * buttonCount,
        editor: editor,
        open: open,
        forceBelowSelection: workaroundLinkBubble
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn('ds-surface-tertiary'),
        style: {
            maxWidth: '100vw',
            display: 'flex',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ React.createElement(BlockFormatting, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Bold, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Italic, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Underline, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Strike, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Separator, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Link, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Separator, {
        hideWhen: 'link',
        editor: editor
    }), /*#__PURE__*/ React.createElement(Alignment, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Indent, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Outdent, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Blockquote, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(OrderedList, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(BulletList, {
        editor: editor
    }), !omitHRule && /*#__PURE__*/ React.createElement(HRule, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Separator, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(ClearFormatting, {
        editor: editor
    })));
};
FormatBubbleMenu.displayName = 'FormatBubbleMenu';
export default FormatBubbleMenu;

//# sourceMappingURL=FormatBubbleMenu.js.map